import exif from 'exif-js';
import gpsHandler from './gpsHandler';
import { Bus, Stops } from '../bus';

export default {
    parse(image) {
        const self = this;
        exif.getData(image, function handle() {
            if (!this || !this.exifdata) return;
            gpsHandler.parseGPS(this.exifdata.GPSLatitude, this.exifdata.GPSLatitudeRef, this.exifdata.GPSLongitude, this.exifdata.GPSLongitudeRef);
            self.parseDateTime(this.exifdata.DateTimeOriginal);
        });
    },
    parseDateTime(original) {
        if (!original) return;
        const year = original.substring(0, 4);
        const month = original.substring(5, 7);
        const day = original.substring(8, 10);
        const time = original.substring(11, 16);
        Bus.$emit(Stops.DATE_PARSED, `${year}-${month}-${day}T${time}`);
    },
};
